<template>
    <div>
        <article-preview :key="itemId" v-for="(itemId) in cart.shoppingCartItemList"
                         :article-details="itemArray[itemId].articleDetails"
                         :price="{'value': itemArray[itemId].totalCalculated, 'currency' : itemArray[itemId].articlePrice.currency}"
                         :thumbnail="itemArray[itemId].articleVariant.thumbnail"/>
        <b-container>
            <b-row class="my-3 summary">
                <b-col class="text-left">
                    <b>Price</b>
                </b-col>
                <b-col class="text-right">
                    <b>{{total | currency($currencyFormatting[currency])}}</b>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-button :to="{ name: 'cart', params: {cartId: cart.id}}" tag="button"
                              @click.stop="$emit('navigate')"
                              class="btn-block my-2">GO TO SHOPPINGBAG
                    </b-button>
                    <b-button :to="{ name: 'checkout', params: {cartId: cart.id}}" tag="button" variant="primary"
                              @click.stop="$emit('navigate')"
                              class="btn-block my-2">GO TO CHECKOUT
                    </b-button>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>

    import {mapGetters, mapState} from "vuex";
    import CartBase from "../../../../pages/Cart/CartBase";
    import ArticlePreview from "../../../../../components/dropdown-nav/ArticlePreview";

    export default {
        name: 'cart',
        extends: CartBase,
        props: {
            cart: {
                type: Object
            }
        },
        methods: {
            fetchArticleDetails() {
                return this.item.articleDetails;
            }
        },
        components: {
            'article-preview': ArticlePreview
        },
        computed: {
            ...mapGetters('cart', ['cartArray', 'itemArray']),
            ...mapState("cart", ['loadingCart'])
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .summary {
        font-size: 15px;
        font-weight: 600;
    }
</style>
